import { render, staticRenderFns } from "./Repos.vue?vue&type=template&id=a265e1e8&"
import script from "./Repos.vue?vue&type=script&lang=js&"
export * from "./Repos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports